<template>
  <Badge :text="config.label" :color="config.bg" :textColor="config.text" />
</template>
<script>
import Badge from "./Badge.vue";

// Situacoes vindas de gspro12-api#456 (GET nota/status-diario).
const SITUACOES = {
  confirmada: { label: "Confirmada", bg: "#e8fce8", text: "#28c76f" },
  falhou: { label: "Falhou", bg: "#fce3e3", text: "#ea5455" },
  processando: { label: "Processando", bg: "#dff2f0", text: "#00BBA2" }
};

export default {
  name: "StatusBadge",
  components: { Badge },
  props: {
    situacao: { type: String, required: true }
  },
  computed: {
    config() {
      return SITUACOES[this.situacao] || { label: this.situacao, bg: "#f1f2f4", text: "#9a9a9a" };
    }
  }
};
</script>
